import { ClickEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutEdiProfileStatusQuickInfo } from "./autogen/AutogenLayoutEdiProfileStatusQuickInfo";
import { EdiUtility } from "./EdiUtility";
import { StatusProfile } from "./StatusProfile";

export class EdiProfileStatusQuickInfo extends AutogenLayoutEdiProfileStatusQuickInfo {

    doAfterExecute(event: DataSourceExecutionEvent) {
        if (StringUtil.isEmptyString(this.sourceEdistatusProfile.activeRow?.get("notes"))) {
            this.labelPartnerNotesImage.enabled = false;
            this.labelPartnerNotesImage.imageColor = "subtle.light";
            this.labelPartnerNotesImage.tooltip = "No partner notes available"
        }
    }

    openClassicPartnerProfile(event: ClickEvent): void {
        const id = this.sourceEdistatusProfile?.activeRow?.get("id");
        if (id != null) {
            StatusProfile.navigateTo(id);
        }
    }

    showPartnerNotes() {
        EdiUtility.showPartnerNotes(this.sourceEdistatusProfile.activeRow?.get("id"),
            this.sourceEdistatusProfile.activeRow?.get("partner_name"), this.sourceEdistatusProfile.activeRow?.get("notes"));
    }

}
